<template>
  <div class="p-2">
    <a class="block hover:bg-gray-50">
      <div class="px-4 py-4 sm:px-6">
        <div class="flex items-center justify-between">
          <div> {{ `${$t('issues.singular_issue_label')} #${issueData.id}: ${truncate(issueData.description)}` }} </div>

          <div class="mt-2 flex items-center text-sm text-gray-500 sm:mt-0">
            <b class="mr-1"> {{ $t('issues.topic_label') }}: </b> {{ topic }}
          </div>
        </div>

        <div class="mt-1 sm:flex sm:justify-between">
          <div class="sm:flex">
            <div class="flex items-center text-sm text-gray-500">
              <div class="mt-2 flex items-center text-sm text-gray-500 sm:mt-0">
                <p>
                  <time datetime=""> {{ $t('issues.created_label', { created_at: this.issueData.created_at, created_by: `${this.issueData.relationships.created_by.first_name} ${this.issueData.relationships.created_by.last_name}` }) }} </time>
                </p>

                <div class="ml-2 flex-shrink-0 flex">
                  <span v-if="issueData.aasm_state == 'open'" class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-200 text-green-800"> {{ $t('issues.open_status') }} </span>
                  <span v-if="issueData.aasm_state == 'under_review'" class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-blue-200 text-blue-800"> {{ $t('issues.under_review_status') }} </span>
                  <span v-if="issueData.aasm_state == 'closed'" class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-200 text-red-800"> {{ $t('issues.closed_status') }} </span>
                </div>
              </div>
            </div>
          </div>

          <div class="mt-2 flex items-center text-sm text-gray-500 sm:mt-0">
            {{ $t('issues.last_updated_label', { updated_at: this.timeSince(this.issueData.updated_at_lux) }) }}
          </div>
        </div>
      </div>
    </a>
  </div>
</template>

<script>
  export default {
    name: '',
    data () {
      return {
      }
    },
    computed: {
      topic () {
        if (this.issueData.topic.includes('_')) {
          let topicString = ''

          this.issueData.topic.split('_').forEach(i => {
            topicString = topicString + `${i[0].toUpperCase() + i.slice(1)} `
          })

          return topicString
        }

        return this.issueData.topic[0].toUpperCase() + this.issueData.topic.slice(1)
      },
    },
    methods: {
      truncate (string) {
        let amountToTruncate = 20
        return string.length > amountToTruncate ? `${string.substring(0, amountToTruncate)}...` : `${string.substring(0, amountToTruncate)}`
      },
      timeSince(date) {
        let seconds = Math.floor((new Date() - date) / 1000)

        let interval = seconds / 31536000

        if (interval > 1) {
          return Math.floor(interval) == 1 ? (Math.floor(interval) + " year") : (Math.floor(interval) + " years")
        }
        interval = seconds / 2592000
        if (interval > 1) {
          return Math.floor(interval) == 1 ? (Math.floor(interval) + " month") : (Math.floor(interval) + " months")
        }
        interval = seconds / 86400
        if (interval > 1) {
          return Math.floor(interval) == 1 ? (Math.floor(interval) + " day") : (Math.floor(interval) + " days")
        }
        interval = seconds / 3600
        if (interval > 1) {
          return Math.floor(interval) == 1 ? (Math.floor(interval) + " hour") : (Math.floor(interval) + " hours")
        }
        interval = seconds / 60
        if (interval > 1) {
          return Math.floor(interval) == 1 ? (Math.floor(interval) + " minute") : (Math.floor(interval) + " minutes")
        }

        return Math.floor(seconds) == 1 ? (Math.floor(seconds) + " second") : (Math.floor(seconds) + " seconds")
      },
    },
    props: {
      issueData: {
        type: Object,
      },
    },
  }
</script>

<style lang="scss">
</style>
